module.exports = __webpack_public_path__ + "img/qiwi.e22769dc.svg";